import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import PageTabHeader from "@/App/Layouts/PageBody/PageTabHeader";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import ViewContentBlockHeader from "@/App/Layouts/ViewContentBlockHeader";
import { ViewLayout } from "@/App/Layouts/ViewLayout";
import GeneralAddressCompactDisplay from "@/common/components/Entity/General/GeneralAddress/GeneralAddressCompactDisplay";
import EntityChangedByInfoCard from "@/common/components/EntityInfo/EntityChangedByInfoCard";
import InlineApiEnumValue from "@/common/components/Enum/InlineApiEnumValue";
import FieldValue from "@/common/components/Form/Display/FieldValue";
import { ViewVariant } from "@/common/ts/layout";
import { AppPermission, CustomerDto, EntityType } from "@/core/api/generated/v1";

import EntityAffiliationInfoBlock from "../../../EntityAffiliation/EntityAffiliationInfoBlock";
import CustomerContactCard from "../../CustomerContactCard";

interface Props {
  customer: CustomerDto;
  onUpdate: (newValue?: CustomerDto) => void;
}

export default function OverviewTabContent({ customer, onUpdate }: Props) {
  return (
    <PageTabContent>
      <ViewLayout
        displayProps={{ viewVariant: ViewVariant.Tab }}
        header={
          <PageTabHeader
            title={"Details"}
            subtitle2={<EntityChangedByInfoCard entity={customer} />}
          />
        }
      >
        <ViewContentBlock>
          <FieldValue label='Type'>
            <InlineApiEnumValue type='CustomerType' value={customer?.type} withDescription />
          </FieldValue>

          <FieldValue label='Name'>{customer?.name}</FieldValue>

          <FieldValue label='Address' isEmpty={!customer?.address || customer?.address.isEmpty}>
            <GeneralAddressCompactDisplay address={customer?.address} />
          </FieldValue>

          <FieldValue label='Notes'>{customer?.notes}</FieldValue>
        </ViewContentBlock>

        {/* Affiliation */}
        <EntityAffiliationInfoBlock
          entityType={EntityType.Customer}
          entityId={customer.id}
          entity={customer}
          entityUpdatePermission={AppPermission.CustomerManage}
          infoDisplayProps={{
            withoutTenant: true,
          }}
          onUpdate={onUpdate}
        />

        <ViewContentBlock>
          <ViewContentBlockHeader>Contacts</ViewContentBlockHeader>
          <Stack spacing={1}>
            {customer?.contacts!.map((contact) => (
              <CustomerContactCard key={contact.id} contact={contact} sx={{ minWidth: 300 }} />
            ))}
          </Stack>
        </ViewContentBlock>
      </ViewLayout>
    </PageTabContent>
  );
}
